import { z } from "zod";

export const EMAIL_TEMPLATE_KEYS = [
  "landing-page-inquiry",
  "meeting-agenda",
  "project-invite",
  "reset-password",
  "task-notify",
  "test-mail",
] as const;

export const ZEmailTemplateKey = z.enum(EMAIL_TEMPLATE_KEYS);
export type IEmailTemplateKey = z.infer<typeof ZEmailTemplateKey>;

export const EMAIL_TEMPLATE_ALLOWED_FILES = [
  "html.hbs",
  "html.hbs.json",
  "html.handlebars.json",
  "styles.css",
  "subject.html",
  "subject.pug",
  "text.pug",
  "html.pug",
] as const;

export const ZEmailTemplateFilename = z.enum(EMAIL_TEMPLATE_ALLOWED_FILES);
export type IEmailTemplateFilename = z.infer<typeof ZEmailTemplateFilename>;

export const EMAIL_TEMPLATE_MANIFEST: Record<IEmailTemplateKey, readonly IEmailTemplateFilename[]> = {
  "landing-page-inquiry": ["html.hbs"],
  "meeting-agenda": ["html.hbs", "html.hbs.json"],
  "project-invite": ["html.hbs", "html.handlebars.json"],
  "reset-password": ["html.hbs", "styles.css", "subject.html", "subject.pug"],
  "task-notify": ["html.hbs", "html.hbs.json"],
  "test-mail": ["html.pug"],
} as const;

export const EMAIL_TEMPLATE_PRIMARY_HTML_FILE: Record<IEmailTemplateKey, IEmailTemplateFilename> = {
  "landing-page-inquiry": "html.hbs",
  "meeting-agenda": "html.hbs",
  "project-invite": "html.hbs",
  "reset-password": "html.hbs",
  "task-notify": "html.hbs",
  "test-mail": "html.pug",
} as const;

export const getEmailTemplatePath = (key: IEmailTemplateKey) => `emails/${key}`;

export const getEmailTemplateFilePath = (key: IEmailTemplateKey, filename: IEmailTemplateFilename) =>
  `${getEmailTemplatePath(key)}/${filename}`;

export const getEmailTemplateFiles = (key: IEmailTemplateKey): readonly IEmailTemplateFilename[] =>
  EMAIL_TEMPLATE_MANIFEST[key];
